import {RootState, store} from './redux/store';
import {customElement, state, property} from 'lit/decorators.js';
import {css, html, LitElement, PropertyValues} from "lit";
import {connect} from 'pwa-helpers/connect-mixin.js';
import {GridFlexCss, StyleGeneral} from "./const";
import {msg, localized} from '@lit/localize';
import './step/services';
import './step/booking';
import './step/register';
import './component/loader.component';
import './component/alert.component';
import {setLocaleFromUrl} from "./localization";
import {selectLang} from "./redux/reducers/reducers";

/**
 * An example element.
 */
@localized()
@customElement('iblu-app')
export class MyElement extends connect(store)(LitElement) {
    static override styles = [
        GridFlexCss,
        StyleGeneral, css`
        .animated {
          animation-duration: 1s;
          animation-fill-mode: both;
          -webkit-animation-duration: 1s;
          -webkit-animation-fill-mode: both
        }
        
        .container {
          max-width: 790px;
          display: block;
          margin: auto;
          animation-name: fadeInUp;
          -webkit-animation-name: fadeInUp;
        }
        
        @-webkit-keyframes fadeInUp {
          from {
            transform: translate3d(0, 80px,0)
          }

          to {
            transform: translate3d(0,0,0);
            opacity: 1
          }
        }
        `
    ];


    @state()
    private _step: number | null = 0;

    @property({ type: String, attribute: true })
    override lang = "" ;


    constructor() {
        super();
    }

    override willUpdate(changedProperties: PropertyValues<this>){
        if (changedProperties.has('lang') || changedProperties.has('lang')) {
            this.localeChanged();
            store.dispatch(selectLang(this.lang));
            setTimeout(()=>{
                this._step = 1;
            }, 2000)
        }

    }

    override render() {
        const content = html`
            <h2 class="text-center"> ${msg(html`Veuillez Choisir`)}</h2>
            <p class="text-center">${msg(html`Un Produit et nous vous trouverons la meilleure solution.`)}</p>
        `;
        if(this._step == 0) {
            return html`
              <iblu-loader></iblu-loader>
        `;
        }
        else if(this._step == 1){
            return html`
                ${content}
            <div class="animated container">
                <iblu-services></iblu-services>
            </div>
        `;
        }
        else if (this._step == 2) {
            return html`
                ${content}
            <div class="animated container">
                <iblu-booking></iblu-booking>
            </div>
        `;
        }
        else if (this._step == 3) {
            return html`
                ${content}
            <div class="animated container">
                <iblu-register></iblu-register>
            </div>`;
        }
        else if(this._step == 4){
            return html`
                <div class="animated container">
                    <iblu-alert></iblu-alert>
                </div>`;
        }else{
            return html`
                <div class="animated container">
                    <p>¡Unknown process!</p>
                </div>`;
        }

    }
    override stateChanged(state: RootState) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if(this._step >= 1){
            this._step = state.data.step;
        }
    }

    localeChanged() {
        const url = new URL(window.location.href);
        url.searchParams.set('locale', this.lang);
        window.history.pushState(null, '', url.toString());
        setLocaleFromUrl();
    }

}

declare global {
    interface HTMLElementTagNameMap {
        'iblu-app': MyElement;
    }
}
